<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Latest Events',
          to: {
            name: 'LatestEvent'
          }
        },
        { name: 'Edit',
          to: {
            name: 'LatestEventsEdit',
            params: {
              id: $route.params.id,
            }
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Event</h2>
      <v-spacer></v-spacer>
      <button class="button btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!-- Block -->
    <LatestEventsCreateEdit></LatestEventsCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import LatestEventsCreateEdit from '@/views/I-2_IR-LatestEvents/c/LatestEventsCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    LatestEventsCreateEdit,
  },
  async created() {
    if (this.$route.params.id) {
      await this.getShareholderEvent(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('shareholderEvent', ['shareholderEvent']),
  },
  methods: {
    ...mapActions('shareholderEvent', {
      getShareholderEvent: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'LatestEvent' });
    },
    saveHandler() {
      this.save(this.shareholderEvent).then(() => {
        this.$router.push({ name: 'LatestEvent' });
      });
    },
  },
};
</script>

<style></style>
